import React, { useState, useEffect } from 'react';

import { Container, Typography, Alert } from '@mui/material';
import { useSearchParams  } from 'react-router-dom';
import axios from 'axios';
//import { startRegistration } from '@simplewebauthn/browser';

const ValidateRegistrationPage = () => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get("email"));
  const [token, setToken] = useState(searchParams.get("token"));

  useEffect(() => {
    setEmail(searchParams.get("email"));
    setToken(searchParams.get("token"));
    
    const handleLoad = async (e) => {
      // Perform actions after the component has fully loaded
      e.preventDefault();
      setError('');
      setSuccess('');

      try {

        const verifyResponse = await axios.post('/api/webauthn/verifyemail', {email, token});
        
        if (verifyResponse.data.success){
          setSuccess(verifyResponse.data.message || 'Validace úspěšná');
        } else {
          setError(verifyResponse.data.message || 'Validace neúspěšná');
        }
        
        //setTimeout(() => navigate('/'), 3000);
      } catch (error) {
        setError(error.response?.data?.error || 'Nastala chyba při validaci.');
      }
    };
    window.addEventListener('load', handleLoad);
    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, [searchParams]);

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" component="h1" gutterBottom>
        Validace registovaného zařízení
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}
    </Container>
  );
};

export default ValidateRegistrationPage;